import reprocesarIcon from '../assets/images/reprocesar.png';
import cargarIcon from '../assets/images/cargar.png';
import newUploadIcon from '../assets/images/new_upload.png';
import confirmarIcon from '../assets/images/confirmar.png';
import pdfIcon from '../assets/images/pdf.png';
import xmlAttIcon from '../assets/images/xml-att.png';
import xmlResIcon from '../assets/images/xml-res.png';
import enviarIcon from '../assets/images/enviar.png';

export const images = {
  reprocesar: reprocesarIcon,
  cargar: cargarIcon,
  new_upload: newUploadIcon,
  confirmar: confirmarIcon,
  pdf: pdfIcon,
  xml_att: xmlAttIcon,
  xml_res: xmlResIcon,
  enviar: enviarIcon,
};